module.exports = __webpack_public_path__ + "static/img/third2_2_5_active.3aaae961.jpg";